import { NodeClass } from '@modules/campaigns/Domain/NodeClass';
import { NodeType } from '@modules/campaigns/Domain/Enums/NodeType';
import { ExperimentConfig } from '@modules/campaigns/Domain/Interfaces/INodeConfig';
import { ValidationError } from '@modules/campaigns/Domain/Enums/ValidationErrors';
import { NodeValidationError } from '@modules/campaigns/Domain/Interfaces/NodeValidationError';

export class ConditionalExperimentNode extends NodeClass {
  constructor(id: string, position: { x: number; y: number }, config: ExperimentConfig) {
    super(id, NodeType.Experiment, position, config);
  }

  isEmptyConfig(): boolean {
    return this.config['percentage'] == undefined;
  }

  addChild(node: string): void {
    if (this.childrenNodes.length === 0 || 1) this.childrenNodes.push(node);
    else console.warn('TENEMOS CHILD');
  }

  addParent(node: string): void {
    if (this.parentNodes.length === 0) this.parentNodes.push(node);
    else console.warn('TENEMOS PARENT');
  }

  initNodeConfig() {
    (this.config as ExperimentConfig).percentage = 1;
    (this.config as ExperimentConfig).cases = { false: null, true: null };
  }

  validate(): NodeValidationError[] {
    const errors: NodeValidationError[] = [];
    if (
      this.config['percentage'] === '' ||
      Number(this.config['percentage']) < 0 ||
      Number(this.config['percentage']) > 100
    ) {
      errors.push({ nodeId: this.id, errorMessage: ValidationError.NO_PERCENTAGE });
    }

    if (Number(this.config['percentage']) === 0 || Number(this.config['percentage']) === 100) {
      errors.push({
        nodeId: this.id,
        errorMessage: 'La división no puede ser 0 / 100 ni 100 / 0',
      });
    }
    return errors;
  }

  cloneWithConfig(newConfig: Partial<ExperimentConfig>): ConditionalExperimentNode {
    const cfg = { ...((this.config as ExperimentConfig) || {}), ...newConfig } as ExperimentConfig;
    const clone = new ConditionalExperimentNode(
      this.id,
      { x: this.position.x, y: this.position.y },
      cfg,
    );
    clone.childrenNodes = this.childrenNodes.slice();
    clone.parentNodes = this.parentNodes.slice();
    return clone;
  }
}
